import React from "react";
import { Route, Switch, useRouteMatch, Redirect, useLocation } from "react-router-dom";

import CreateFeedPage from "./Pages/CreateFeedPage";
import FeedPage from "./Pages/FeedPage";
import EditFeedPage from "./Pages/EditFeedPage";

export function NewsAdmin() {
  const { path } = useRouteMatch();
  const location = useLocation();
  const pageType = location.state ? location.state.pageType : null;

  return (
    <Switch>
      <Route path={`${path}/feed/new`}>
        <CreateFeedPage />
      </Route>
      <Route path={`${path}/feed/:id`}>
        <EditFeedPage pageType={pageType} />
      </Route>
      <Route path={`${path}/feed`}>
        <FeedPage />
      </Route>

      <Redirect to={`${path}/feed`} />
    </Switch>
  );
}
